import { inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'priceCurrency',
	standalone: true,
})
export class PriceCurrencyPipe implements PipeTransform {
	private readonly locale = inject(LOCALE_ID);

	transform(priceInPennies: number, currencyCode: string): string {
		return new Intl.NumberFormat(this.locale, {
			style: 'currency',
			currency: currencyCode,
			currencyDisplay: 'code',
		}).format(priceInPennies / 100);
	}
}
